import { m, MotionProps } from 'framer-motion';
// @mui
import { Box, BoxProps } from '@mui/material';
// hooks
import useResponsive from '../../hooks/useResponsive';
//
import { varContainer } from './variants';

// ----------------------------------------------------------------------

type IProps = BoxProps & MotionProps;

interface Props extends IProps {
  children: React.ReactNode;
  disableAnimatedMobile?: boolean;
}

export default function MotionViewport({
  children,
  disableAnimatedMobile = true,
  ...other
}: Props) {
  const isMobile = useResponsive('down', 'sm');

  if (isMobile && disableAnimatedMobile) {
    return <Box {...other}>{children}</Box>;
  }

  return (
    <Box
      component={m.div}
      initial="initial"
      whileInView="animate"
      // 'some' (any visible pixel) instead of a fraction: sections taller
      // than ~3x the viewport (e.g. the team section on landscape phones)
      // can never reach a 0.3 visibility ratio and stayed invisible forever
      viewport={{ once: true, amount: 'some' }}
      variants={varContainer()}
      {...other}
    >
      {children}
    </Box>
  );
}
